import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  Self,
} from '@angular/core';
import { TooltipDirective } from '@rivet-health/design-system';

function scrolled(element: HTMLElement): boolean {
  return element.offsetWidth < element.scrollWidth;
}

/**
 * Truncate the text to one line. When truncated, display the full text in a tooltip.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [TooltipDirective],
  selector: '[truncate]',
  styleUrls: ['./truncate.component.scss'],
  templateUrl: './truncate.component.html',
})
export class TruncateComponent {
  constructor(
    private readonly element: ElementRef,
    // For performance reasons, take more control
    @Self() private readonly tooltip: TooltipDirective,
  ) {}

  @Input()
  maxTooltipWidth: string = '200px';

  @HostListener('mouseenter')
  enter() {
    if (scrolled(this.element.nativeElement)) {
      this.tooltip.rivTooltip = this.element.nativeElement.textContent;
      this.tooltip.rivTooltipMaxWidth = this.maxTooltipWidth;
      this.tooltip.onMouseEnter();
    }
  }

  @HostListener('mouseleave')
  leave() {
    this.tooltip.onMouseLeave();
  }

  // For the auto-complete textbox.
  scrollIntoView() {
    this.element.nativeElement.scrollIntoView(false);
  }
}
